import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20sunset%20over%20a%20peaceful%20Chinese%20countryside%20farm%20with%20free%20range%20chickens%20returning%20to%20coop%2C%20golden%20light%20bathing%20the%20landscape%2C%20rustic%20wooden%20farm%20buildings%2C%20gentle%20rolling%20hills%2C%20serene%20agricultural%20atmosphere%2C%20soft%20warm%20colors%2C%20nostalgic%20rural%20aesthetic&width=1800&height=500&seq=cta-bg&orientation=landscape"
        alt="开始您的养殖之旅"
        title="加入大鸡巴养殖大家庭"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/40 to-black/50"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-white mb-4">
          准备好开始您的养殖之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/85 mb-8 leading-relaxed max-w-xl mx-auto">
          无论您是养殖新手还是经验丰富的从业者，大鸡巴品种科普都为您提供最全面、最专业的知识支持，助您在养殖道路上稳步前行。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/breeding"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-seedling-line"></i>
            学习养殖技术
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white rounded-md font-medium text-sm whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer border border-white/30"
          >
            <i className="ri-mail-send-line"></i>
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}